import { Button, ButtonProps } from '@chakra-ui/react';
import { ChevronRight } from 'lucide-react';

interface CTAButtonProps extends ButtonProps {
  text: string;
}

const CTAButton = ({ text, ...props }: CTAButtonProps) => (
  <Button
    variant='primary'
    size='lg'
    rightIcon={<ChevronRight size={20} />}
    px={8}
    _hover={{
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 20px rgba(70, 255, 255, 0.3)',
    }}
    {...props}>
    {text}
  </Button>
);

export default CTAButton;
